import React from "react";

export default function ProcessingDialog({ visible, message = "Procesando solicitud..." }) {
    if (!visible) return null;
    return (
        <div className="fixed inset-0 z-[1100] bg-black/40 flex items-center justify-center">
            <div className="bg-white rounded-lg shadow-lg border border-gray-200 px-6 py-5 w-full max-w-sm">
                <div className="flex items-center gap-4">
                    <div className="h-8 w-8 rounded-full border-2 border-blue-500 border-t-transparent animate-spin" />
                    <div className="flex-1">
                        <p className="text-sm font-medium text-gray-900">{message}</p>
                        <p className="text-xs text-gray-500 mt-0.5">Por favor espera...</p>
                    </div>
                </div>
            </div>
        </div>
    );
}


